import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { SURVEYS_QUERY_BASE_KEY, SURVEYS_STALE_TIME } from '../query';
import type { Clause } from '../Responses/Filters/Clause';
import type { QuestionResults } from './AggregatedResult';
import { getQuestionResults } from './getQuestionResults';

const SURVEYS_QUERY_RESULTS_KEY = 'results';

export const useQuestionResultsQuery = (
  siteId: number | string | undefined,
  surveyId: number | undefined,
  clauses: Clause[] | undefined,
): UseQueryResult<QuestionResults, Error> => {
  const hasRequiredProps = siteId !== undefined && surveyId !== undefined && clauses !== undefined;

  return useQuery(
    [SURVEYS_QUERY_BASE_KEY, SURVEYS_QUERY_RESULTS_KEY, { siteId }, { surveyId }, { clauses }],
    () => {
      if (!hasRequiredProps) throw new Error('Missing required props');
      return getQuestionResults(siteId, surveyId, clauses);
    },
    {
      staleTime: SURVEYS_STALE_TIME,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      keepPreviousData: true,
      enabled: hasRequiredProps,
    },
  );
};
